import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
import { PayGatewayComponent } from '../pay-gateway/pay-gateway.component';
 
@Component({
  selector: 'app-exam-fee-process',
  templateUrl: './exam-fee-process.component.html',
  styleUrls: ['./exam-fee-process.component.scss']
})
export class ExamFeeProcessComponent implements OnInit {
  FeeForm: FormGroup;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  AdModeList: any;
  filteredAdModeList: any;
  SRList: any;
  filteredSR: any;
  totalAmount = 0;
  lvl: 0;
  zeroError = false;
  inputTimeout: any;
  arrTest: any = [];
  tabldata: any;
  selectedoption: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  totalPayableAmount: number;
  totalPayAmount = 0;
  remainAmt = 0;
  StudentPersonalId;
  feeMode;
  tabldata2: any;
  ramt: number;
  Total = true;
  Message = false;
  due: number;
  RAmt
  submitButton = true;
  updateButton = false;
  feeApplyArray: FormArray;
  updateBtn = true;
  payHistoryBtn = false;
  disablePaid = true
  xyz: any;
  errMsg: any;
  payModeList: any;
  shouldShowErrorMessage: boolean = false;
  lastPaid: any;
  newPaid: any;
  filteredpayModeList: any;
  SnNo: any;
  filteredElements: any;
  FeeLevel: any;
  feeModeShow = true;
  ExamCurrency
  examFeeType: any;
  ExamFee: any;
  hasMultipliedFee: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService, public dialogRef1: MatDialogRef<ExamFeeProcessComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  FeeTable: any;
  tempCo = sessionStorage.getItem('TemplateCode');
  ngOnInit(): void {
    this.payHistoryBtn = false;
    this.getFeeTempData()
    this.updateBtn = true;
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    this.totalAmount = 0;
    this.totalPayAmount = 0;
    this.remainAmt = 0;
    this.Total = true;
    this.Message = false;
    this.ramt = 0;
    this.due = 0;
    this.lvl = 0;
 
    this.FeeForm = this.fb.group({
      TemplateName: new FormControl('', [Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
      StudentType: new FormControl('', []),
      StudentStatus: new FormControl(''),
      SocialReservation: new FormControl(''),
      TotalPaidAmount: new FormControl('', Validators.required),
      PayMode: new FormControl(''),
      feeHeadArray: new FormArray([]),
 
    });
    this.fetchStudentType()
    this.fetchStudentStatus()
    this.fetchSocialReservation();
    this.fetchAddmissionMode();
 
    this.fetchPayMode();
 
 
  }
 
  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
      payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    payload['FeeType'] = 'EF';
    payload['EmId'] = this.data.EmId
    this.umsService.fetchFeeTemp(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.FeeLevel = res.data[0]['FeeLevel']
        this.ExamCurrency = res.data[0].Currency
        if (res.data[0]['FeeLevel'] == 'SW') {
          this.getRgId()
        }
        else if (res.data[0]['FeeLevel'] == 'EW') {
          this.getRgId()
          // this.getSecretData()
        }
      } else {
        this.getSecretData()
        this.FeeLevel = null
      }
    });
  }
 
  getRgId() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        // this.searchExams(res.data[0]['RgId'])
        this.GetEcId(res.data[0]['RgId'])
      }
      else {
      }
    })
  }
 
  GetEcId(RgId){
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
 
      }
    });
  }
 
  searchExams(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
 
      }
    });
  }
 
  ExmFormSub(EcId, RgId) {
    this.filteredElements = []
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.filteredElements = res.data.filter(element => {
          if (element.EsType == 'S' && (element.App == 'Y' || element.App == ' ')) {
            return element
          }
        });
        this.getSecretData()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
 
 
 
  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
      this.prepopulation(res.projectPharam['SnNo']);
    })
 
  }
 
  fetchStudentType() {
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
      } else {
        
      }
    });
  }
 
  fetchStudentStatus() {
    const payload = {};
    payload['CdType'] = 'STUST';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.stuStatusList = res.data;
        this.filteredstuStatusList = this.stuStatusList.slice();
      } else {
        
      }
    });
  }
 
  fetchSocialReservation() {
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
      } else {
        
      }
    });
  }
  fetchAddmissionMode() {
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.AdModeList = res.data;
        this.filteredAdModeList = this.AdModeList.slice();
      } else {
        
      }
    });
  }
 
  addNewRow() {
    const creds = this.FeeForm.controls.feeHeadArray as FormArray;
    creds.push(
      this.fb.group({
        FeeHead: new FormControl('', [Validators.required]),
        HeadName: new FormControl('',),
        FeePaid: new FormControl(0),
        FeeDue: new FormControl(0),
        FeeDueDummy: new FormControl(0),
        FeeAmt: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      })
    );
 
  }
 
 
 
  prepopulation(SnNo) {
    this.Total = true;
    this.Message = false;
    this.spinner.show();
    const payload = {};
    
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = SnNo;
    payload['FeeType'] = 'EF';
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      let data = res.data[0];
      this.spinner.hide();
      if (res.status) {
        this.updateButton = true;
        this.submitButton =false;
        this.payHistoryBtn = true;
       this.tabldata2 = res.data;
        this.FeeForm = this.fb.group({
          
          TotalPaidAmount: new FormControl(''),
          PayMode: new FormControl(data.PayMode),
          feeHeadArray: new FormArray([]),
        });
        this.tabldata2 = res.data;
        this.lastPaid = data.TotalPaidAmount
        const currentDate = new Date().toISOString().split('T')[0];

        const currentFees = this.tabldata2.filter(fee => {
          if(!fee.EmFeeFromDate && !fee.EmFeeToDate){

            return true
          }
          // Convert the FeePaymentDate, EmFeeFromDate, and EmFeeToDate to Date objects
          const paymentDate = new Date(fee.FeePaymentDate).toISOString().split('T')[0]; // Only date part, "YYYY-MM-DD"
          const fromDate = new Date(fee.EmFeeFromDate).toISOString().split('T')[0];  // Only date part, "YYYY-MM-DD"
          const toDate = new Date(fee.EmFeeToDate).toISOString().split('T')[0];  // Only date part, "YYYY-MM-DD"
          // Check if FeePaymentDate is between EmFeeFromDate and EmFeeToDate (inclusive)
          return paymentDate >= fromDate && paymentDate <= toDate;
        });
        this.examFeeType = currentFees[0].EmFeeType
        currentFees.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              HeadName: new FormControl(element.Head),
              FeePaid: new FormControl(0),
              FeeDue: new FormControl(element.FeeDue),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeeAmt: new FormControl(element.FeeAmount, [Validators.required, Validators.pattern('^[0-9]*$')]),
              FeeType: new FormControl(element.EmFeeType),
            })
          );
          this.FeeForm.controls['TotalPaidAmount'].setValue('');
          if (this.FeeLevel == 'SW') {
            let totalFee = 0;
            currentFees.forEach(item => {
              const isAnyFeeMultiplied = currentFees.some(item => item.IsMultiply === true);
              this.hasMultipliedFee = isAnyFeeMultiplied;
              
              
              if (item.IsMultiply == true) {
                totalFee += item.FeeAmount * this.filteredElements.length; 
                this.ExamFee = item.FeeAmount // Multiply by number of subjects
              } else {
                totalFee += item.FeeAmount;  // Normal fee, no multiplication
              }
            });
            // let amount = parseInt(element.EmFeeTotal) * this.filteredElements.length
            // this.totalAmount = this.totalAmount + amount;
            this.totalAmount = totalFee
            this.remainAmt = this.totalAmount - this.lastPaid
            this.totalPayAmount = this.totalAmount - this.remainAmt;
            this.ramt = this.remainAmt;
            // this.FeeForm.controls['TotalPaidAmount'].setValue(this.totalAmount);
            if (this.remainAmt == 0) {
              this.payHistoryBtn = true
            }
            else {
              this.payHistoryBtn = false
            }
            if (this.totalAmount == 0) {
              this.FeeForm.controls['TotalPaidAmount'].setValue(0);
              this.updateBtn = false;
            } else {
              this.FeeForm.controls['TotalPaidAmount'].setValue(this.totalAmount);
            }
          }
             else if (this.FeeLevel == 'EW') {
            let totalFee = 0;
            currentFees.forEach(item => {
              totalFee += item.FeeAmount;
            });
            // this.totalAmount = this.totalAmount + parseInt(element.FeeAmt);
            this.totalAmount = totalFee
            this.remainAmt = this.totalAmount - this.lastPaid
            this.totalPayAmount = this.totalAmount - this.remainAmt;
            this.ramt = this.remainAmt;
            if (this.remainAmt == 0) {
              this.payHistoryBtn = true
            }
            else {
              this.payHistoryBtn = false
            }
            if (this.totalAmount == 0) {
              this.FeeForm.controls['TotalPaidAmount'].setValue(0);
              this.updateBtn = false;
            } else {
              this.FeeForm.controls['TotalPaidAmount'].setValue(this.totalAmount);
            }
          }
          if (this.remainAmt == 0) {
            this.updateBtn = true;
            this.Total = false;
            this.Message = true;
            this.payHistoryBtn = true
          } else {
            this.updateBtn = false;
            this.Total = true;
            this.Message = false;
            this.payHistoryBtn = false
          }
        });
      } else {
        this.spinner.show();
        const payload = {};
        payload['TemplateCode'] = this.tempCo;
        payload['FeeType'] = ''
        this.updateButton = false;
        this.submitButton = true;
        
        this.totalAmount =0
        this.umsService.getFeeTemplet(payload).subscribe((res) => {
          this.spinner.hide()
          let data = res.data[0];
          if (res.status) {
            this.tabldata = res.data;
            this.FeeForm = this.fb.group({
              
              TotalPaidAmount: new FormControl(''),
              PayMode: new FormControl(data.PayMode),
              feeHeadArray: new FormArray([]),
            });
            this.FeeTable = res.data;
            const currentDate = new Date().toISOString().split('T')[0];
              // Filter fee data where current date is between EmFeeFromDate and EmFeeToDate
              const today = new Date(currentDate);

              const currentFees = this.FeeTable.filter(fee => {

              if (!fee.EmFeeFromDate && !fee.EmFeeToDate) {
                return true;
              }
              const fromDate = new Date(fee.EmFeeFromDate);
              const toDate   = new Date(fee.EmFeeToDate);

              if (fee.EmFeeType === 'RF') {
                return true;
              }

              if (fee.EmFeeType === 'LF') {
                return today > toDate || (today >= fromDate && today <= toDate);
              }

                return false;
              });
            this.examFeeType = currentFees[0].EmFeeType
            currentFees.forEach((element, i) => {
 
              const creds = this.FeeForm.controls.feeHeadArray as FormArray;
              creds.push(
                this.fb.group({
                  FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                  HeadName: new FormControl(element.Head),
                  FeePaid: new FormControl(0),
                  FeeDue: new FormControl(element.FeeAmount),
                  FeeDueDummy: new FormControl(element.FeeAmount),
                  FeeAmt: new FormControl(element.FeeAmount, [Validators.required, Validators.pattern('^[0-9]*$')]),
                  FeeType: new FormControl(element.EmFeeType),
                })
              );
               if (this.FeeLevel == 'SW') {
                  let totalFee = 0;
                  currentFees.forEach(item => {
                    const isAnyFeeMultiplied = currentFees.some(item => item.IsMultiply === true);
                    this.hasMultipliedFee = isAnyFeeMultiplied;
                    if (item.IsMultiply == true) {
                      totalFee += item.FeeAmount * this.filteredElements.length;
                      this.ExamFee = item.FeeAmount  // Multiply by number of subjects
                    } else {
                      totalFee += item.FeeAmount;  // Normal fee, no multiplication
                    }
                  });
                // let amount = parseInt(element.EmFeeTotal) * this.filteredElements.length
                // this.totalAmount = this.totalAmount + amount;
                this.totalAmount = totalFee
                this.remainAmt = this.totalAmount;
                this.totalPayAmount = this.totalAmount - this.remainAmt;
                this.ramt = this.remainAmt;
                if (this.totalAmount == 0) {
                  this.FeeForm.controls['TotalPaidAmount'].setValue(0);
                  this.updateBtn = false;
                } else {
                  this.FeeForm.controls['TotalPaidAmount'].setValue(this.totalAmount);
                }
              }
               else if (this.FeeLevel == 'EW') {
                let totalFee = 0;
                currentFees.forEach(item => {
                  totalFee += item.FeeAmount;
                });
                this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
                this.remainAmt = this.totalAmount;
                this.totalPayAmount = this.totalAmount - this.remainAmt;
                this.ramt = this.remainAmt;
                if (this.totalAmount == 0) {
                  this.FeeForm.controls['TotalPaidAmount'].setValue(0);
                  this.updateBtn = false;
                } else {
                  this.FeeForm.controls['TotalPaidAmount'].setValue(this.totalAmount);
                }
              }
            });
 
 
          } else {
            
          }
        });
      }
    });
 
  }
 
 
 
  errorcheckP(i) {
    return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.pattern
 
 
  }
  errorcheckR(i) {
    return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.required
 
  }
 
  getfeeHeadArrayControls() {
    return (this.FeeForm.get('feeHeadArray') as FormArray).controls;
  }
 
  close() {
    this.dialogRef1.close();
  }
 
  submitFeeTemplet() {
    if (this.FeeForm.invalid) {
      this.FeeForm.get('TotalPaidAmount').markAsUntouched();
    }
    else {
      this.submit()
    }
  }
 
  submit() {
    this.spinner.show();
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        if (this.FeeLevel == 'SW') {
          let amtamt = parseInt(element.FeeAmt) * this.filteredElements.length
          arr1.push(
            this.fb.group({
              FeeTemplateCode: new FormControl(this.tempCo), //add neww
              StuId: new FormControl(this.StudentPersonalId),
              FeeType: new FormControl('EF'),
              FeeHead: new FormControl(element.FeeHead),
              FeeStatus: new FormControl('Y'),
              FeeAmt: new FormControl(amtamt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode: new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.SnNo),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount)
            })
          )
        }
        else if (this.FeeLevel == "EW") {
          arr1.push(
            this.fb.group({
              FeeTemplateCode: new FormControl(this.tempCo), //add neww
              StuId: new FormControl(this.StudentPersonalId),
              FeeType: new FormControl('EF'),
              FeeHead: new FormControl(element.FeeHead),
              FeeStatus: new FormControl('Y'),
              FeeAmt: new FormControl(element.FeeAmt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode: new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.SnNo),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount)
            })
          )
        }
        this.umsService.addFeeTemplet(arr1[0].value).subscribe(res => {
         
          if (this.totalAmount == 0) {
            const randomFiveDigitNumber = Math.floor(10000 + Math.random() * 90000);
            let payload = {};
              payload['payment_source'] = 'Pay-0',
              payload['easepayid'] = randomFiveDigitNumber,
              payload['card_type'] = '-',
              payload['mode'] = '-',
              payload['email'] = '',
              payload['phone'] = '',
              payload['key'] = '',
              payload['txnid'] = '',
              payload['status'] = 'Success',
              payload['amount'] =  arr1[0].value.TotalPaidAmount,
              payload['StuId'] = this.StudentPersonalId,
              payload['FeeTemplateCode'] = this.tempCo,
              payload['FeeType'] = 'EF',
              payload['SnNo'] = this.SnNo.toString(),
              payload['firstname'] = arr1[0].value.FeeHead,
              this.umsService.payZeroFee(payload).subscribe((res) => {
                if (res.status) {
                  
                  this.spinner.hide()
                  let data = {}
                   data['message'] = "Waved Off",
                   data['title'] = 'Information'
                   data['icon'] = 'fas fa-check'
                  this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
                  this.ngOnInit();
                }
                else {
                  this.spinner.hide()
                  let data = {}
                  data['message'] = res.message,
                  data['title'] = 'Alert'
                  data['icon'] = 'fas fa-close'
                  this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  
                }
              });

            // this.onPaymentRequest(arr1[0].value);
          }
         else {
            const paymentDetails = {
            "amount": arr1[0].value.TotalPaidAmount,
            "StuId": this.StudentPersonalId,
            "FeeTemplateCode": this.tempCo,
            "FeeType": 'EF',
            "SnNo": this.SnNo.toString(),
            "firstname": arr1[0].value.FeeHead,
            "email": "jeeevishnu@gmail.com",
            "phone": "8296270993"
          }
          this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
            window.location.href = response.redirectUrl;
            
          });
        }
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length -1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        // this.openGatewayPopUp(this.FeeForm.value)
        this.saveApplicationDetails();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
 
      }
    });
 
  }
 
 

// Add a flag to track whether a popup is already being shown
private isPopupShown = false;

async onPaymentRequest(value) {
  const randomFiveDigitNumber = Math.floor(10000 + Math.random() * 90000);
  let payload = {
    payment_source: 'Pay-0',
    easepayid: randomFiveDigitNumber,
    card_type: '-',
    mode: '-',
    email: '',
    phone: '',
    key: '',
    txnid: '',
    status: 'Success',
    amount: value.TotalPaidAmount,
    StuId: this.StudentPersonalId,
    FeeTemplateCode: this.tempCo,
    FeeType: 'EF',
    SnNo: this.SnNo.toString(),
    firstname: value.FeeHead
  };

  try {
    // Show spinner before API call
    this.spinner.show();

    // Await the API response
    const res = await this.umsService.payZeroFee(payload).toPromise();

    // Hide spinner once response is received
    this.spinner.hide();

    // Show popup based on response, but only if no popup is already shown
    if (!this.isPopupShown) {
      this.isPopupShown = true; // Mark that a popup is being shown

      if (res.status) {
        this.showPopup('Waved Off', 'Information', 'fas fa-check');
      } else {
        this.showPopup(res.message, 'Alert', 'fas fa-close');
      }
    }

    // Reload data after successful API call
    if (res.status) {
      this.ngOnInit();
    }

  } catch (error) {
    // Handle any error from the API call
    this.spinner.hide();

    if (!this.isPopupShown) {
      this.isPopupShown = true;
      this.showPopup('An error occurred while processing the payment.', 'Error', 'fas fa-exclamation-circle');
    }
  }
}

// A helper function to show the popup message
private showPopup(message: string, title: string, icon: string) {
  const data = {
    message: message,
    title: title,
    icon: icon
  };
  this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

  // After closing the popup, reset the flag
  this.dialogRef.afterClosed().subscribe(() => {
    this.isPopupShown = false;  // Reset the flag once the popup is closed
  });
}

  
  saveApplicationDetails() {
    // const currentDate = new Date();
    // const formattedDate = currentDate.toISOString().slice(0, 10);
    // this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SessionId'] = sessionStorage.getItem('session');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['ApplicationName'] = 'Exam Fees'
    // payload['ApplicationSubDate'] = formattedDate;
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        
      } else {
        
      }
    })
  }
 
  amountCheck(index) {
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(index).get('FeeDue').value;
    this.FeeTable.forEach((element, i) => {
      if (element.FeeAmount < amountValue) {
        let data = {}
        data['message'] = "Payable Amount Should be Less than Or Equal to Due Amount"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
 
      }
    })
  }
 
  getAmount(event: any, i) {
 
  }
 
  onInputChange(val) {
    const tempData = val.target.value;
    this.updateBtn = true;
    //client want to pay zero fee for handicap student 15/10/2024
    // if (tempData.charAt(0) === '0') {
    //   this.zeroError = true;
    // }
    // else if (tempData.charAt(0) !== '0') {
    //   this.zeroError = false;
    // }
    if (tempData == '') {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    if (this.remainAmt == 0 && this.submitButton == true && this.lastPaid == undefined) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.totalAmount - tempData;
    }
 
    if (this.ramt < tempData || tempData > this.totalAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    else if (tempData == 0) {
      this.shouldShowErrorMessage = false;
      // this.updateBtn = true;
      this.newPaid = 0;
    }
    else {
      if (this.lastPaid == undefined && this.submitButton == true) {
        this.shouldShowErrorMessage = false;
       
        this.remainAmt = this.totalAmount - tempData;
        if (this.remainAmt == 0) {
          this.updateBtn = false
         
        } else {
          this.updateBtn = true
         
        }
      }
 
      this.shouldShowErrorMessage = false;
      
      this.remainAmt = this.ramt - tempData;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData);
      if (this.remainAmt == 0) {
        this.updateBtn = false
        
      } else {
        this.updateBtn = true
        
      }
    }
  }
 
 
  dueAmt(event, i) {
    let arrayData = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i);
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeePaid').value;
    amountValue = parseInt(amountValue);
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    if (tempData[i]['FeePaid'] == '') {
      this.due = tempData[i]['FeeDueDummy'];
    }
    else {
      this.due = parseInt(tempData[i]['FeeDueDummy']) - parseInt(tempData[i]['FeePaid']);
    }
    this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
    this.feeApplyArray.at(i).get('FeeDue').setValue(this.due);
 
 
  }
 
  newFun(event, i) {
    let FeeDue1 = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeeDue').value;
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    let sumFeeDue = 0;
    tempData.forEach(element => {
      sumFeeDue += element.FeeDue;
    })
    this.remainAmt = sumFeeDue;
    this.totalPayAmount = this.totalAmount - this.remainAmt;
  }
 
  updateFeeTemplet() {
    if (this.FeeForm.invalid) {
      this.FeeForm.get('TotalPaidAmount').markAsTouched();
    }
    else {
      this.update()
    }
  }
 
  update() {
    this.zeroError = false;
    this.spinner.show();
    this.FeeForm.controls['TotalPaidAmount'].setValue(this.newPaid);
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        if (this.FeeLevel == 'SW') {
          let amtamt = parseInt(element.FeeAmt) * this.filteredElements.length
          arr1.push(
            this.fb.group({
              FeeTemplateCode: new FormControl(this.tempCo), //add neww
              StuId: new FormControl(this.StudentPersonalId),
              FeeType: new FormControl('EF'),
              FeeHead: new FormControl(element.FeeHead),
              FeeStatus: new FormControl('Y'),
              FeeAmt: new FormControl(amtamt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode: new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.SnNo),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount)
            })
          )
        }
        else if (this.FeeLevel == "EW") {
          arr1.push(
            this.fb.group({
              FeeTemplateCode: new FormControl(this.tempCo), //add neww
              StuId: new FormControl(this.StudentPersonalId),
              FeeType: new FormControl('EF'),
              FeeHead: new FormControl(element.FeeHead),
              FeeStatus: new FormControl('Y'),
              FeeAmt: new FormControl(element.FeeAmt),
              FeePaid: new FormControl(element.FeePaid),
              FeeDue: new FormControl(element.FeeAmt),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeePaymentMethod: new FormControl(this.feeMode),
              TotalPaidAmount: new FormControl(this.totalAmount),
              PayMode: new FormControl(this.submitpayload.PayMode),
              SnNo: new FormControl(this.SnNo),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(this.totalAmount)
            })
          )
        }
        this.umsService.updateFeeTemplet(arr1[0].value).subscribe(res => {
 
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          // if (index === array.length -1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            const paymentDetails = {
              "amount": arr1[0].value.TotalPaidAmount,
              "StuId": this.StudentPersonalId,
              "FeeTemplateCode": this.tempCo,
              "FeeType": 'EF',
              "SnNo": this.SnNo,
              "firstname": arr1[0].value.FeeHead,
              "email": "jeeevishnu@gmail.com",
              "phone": "8296270993"
            }
            this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
              window.open(response.redirectUrl, '_blank');
            });
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Update Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef1.close();
        });
      } else {
        this.zeroError = true
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
 
      }
    });
 
  }
 
 
  openHistoryPopup() {
     const dialogRef4 = this.dialog.open(PaymentHistoryComponent,
      {
        disableClose: true,
        width: "900px",
        height: "auto",
      });
    dialogRef4.afterClosed().subscribe((result) => {
 
    });
  }
 
  onInputChange2(val) {
       const tempData = val.target.value;
    if (tempData.TotalPaidAmount == '') {
      this.updateBtn = false;
      this.remainAmt = this.remainAmt;
    }
    if (this.remainAmt == 0 && this.submitButton == true) {
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if (this.remainAmt == 0 && this.updateButton == true) {
       this.remainAmt = 0
    }
    else if (this.remainAmt < tempData.TotalPaidAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if (tempData.TotalPaidAmount == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = 0;
    }
    else {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
 
    }
    if (tempData.TotalPaidAmount == this.totalAmount) {
      const Data = this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element, i) => {
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
      });
    }
  }
 
 
  
  isGreaterThanInput(): boolean {
    const tempData = this.FeeForm.value;
    const Data = this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount > this.totalAmount;
  }
 
  isSmallerThanInput(): boolean {
    const tempData = this.FeeForm.value;
    const Data = this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount < this.totalAmount;
  }
 
 
  getAmount2() {
     const tempData = this.FeeForm.value;
    if (tempData.TotalPaidAmount == '') {
      this.updateBtn = false;
      this.remainAmt = this.remainAmt;
    }
    if (this.remainAmt == 0 && this.submitButton == true) {
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if (this.remainAmt == 0 && this.updateButton == true) {
       this.remainAmt = 0
    }
    else if (this.remainAmt < tempData.TotalPaidAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if (tempData.TotalPaidAmount == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = 0;
    }
    else {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
 
    }
    if (tempData.TotalPaidAmount == this.totalAmount) {
      const Data = this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element, i) => {
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
      });
    }
  }
 
 
  fetchPayMode() {
    const payload = {};
    payload['CdType'] = 'PM';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.payModeList = res.data;
        this.filteredpayModeList = this.payModeList.slice();
      } else {
        
      }
    });
  }

  openGatewayPopUp(item) {
    let data = {};
    data['item'] = item;
    data['PaidAmount'] = this.totalAmount;
    data['FeeType'] = 'EF'
    data['StuId'] = this.StudentPersonalId;
    data['FeeTemplateCode'] = this.tempCo;
    data['SnNo'] = this.SnNo.toString();
    const dialogRef4 = this.dialog.open(PayGatewayComponent,
      {
        disableClose: true,
        width: "600px",
        height: "300px",
        data,
        panelClass: 'custom-dialog-container'
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }
}